import common from './common.json';
import auth from './auth.json';
import dashboard from './dashboard.json';
import settings from './settings.json';
import subscription from './subscription.json';
import admin from './admin.json';
import matura from './matura.json';
import mojeSprawdzenia from './mojeSprawdzenia.json';
import students from './students.json';
import submissionLinks from './submissionLinks.json';
import start from './start.json';

export default {
  common,
  auth,
  dashboard,
  settings,
  subscription,
  admin,
  matura,
  mojeSprawdzenia,
  students,
  submissionLinks,
  start,
};
